import React, { Component } from 'react';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { mergeStyleSets } from 'office-ui-fabric-react';

import { DataJournalisationConsole } from '../../data/DataJournalisationConsole.jsx';

import { Immocom } from '../../specifique/immocom';

//#region CSS
const classNames = mergeStyleSets({
    modalContainer: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '60vh',
        maxWidth: '500px',
        width: '60vw'
    },
    modalHeader: {
        background: '#fd0400',
        color: 'white',
        padding: '8px 28px 0'
    },
    modalBody: {
        flex: '2 2',
        overflowY: 'auto',
        padding: '5px 28px'
    },
    modalFooter: {
        display: 'flex',
        justifyContent: 'center',
        padding: '15px 28px',
    }
});
//#endregion

export class ModalConsole extends Component {
    constructor(props) {
        super(props);

        this.state = {
            onAfficheModalConsole: false
        }
    };

    componentDidMount = () => {
        let chargementJournalisationConsole = DataJournalisationConsole._onChargementJournalisationConsole();

        chargementJournalisationConsole
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    const objetData = responseFetch.reponseAPIobjet;

                    if (objetData === 0) {
                        this.setState({ onAfficheModalConsole: true });
                    }
                }
            });
    };

    render = () => {
        return <Modal
            isOpen={this.state.onAfficheModalConsole}
            onDismiss={() => this.setState({ onAfficheModalConsole: false })}
            containerClassName={classNames.modalContainer}
        >
            <div className={classNames.modalHeader}>
                <h3>Console Option</h3>
            </div>
            <div className={classNames.modalBody}>
                <Icon iconName="Warning" /> Le service Windows des options ne tourne plus.
            </div>
            <div className={classNames.modalFooter}>
                <DefaultButton onClick={() => this.setState({ onAfficheModalConsole: false })} text="Fermer" />
            </div>
        </Modal>
    };
}